/* Tema editorial — FICHA DE PRENSA
   1) reproductor de audio propio (onda real, avance, ±15 s, velocidad)
   2) copiar el enlace del recorte
   Sustituye al <audio controls> nativo; si este script no carga, el reproductor
   nativo del navegador sigue funcionando. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(s) {
    if (!isFinite(s) || s < 0) s = 0;
    s = Math.floor(s);
    var m = Math.floor(s / 60), r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function svg(paths) {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    paths.forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      s.appendChild(p);
    });
    return s;
  }

  function build(fig) {
    if (fig.dataset.pfReady) return;
    var au = fig.querySelector('audio');
    var wave = fig.querySelector('.pf-wave') || (function () {
      var w = document.createElement('div');
      w.className = 'pf-wave';
      w.setAttribute('role', 'slider');
      w.setAttribute('tabindex', '0');
      w.setAttribute('aria-label', 'Avanzar en el audio');
      return w;
    })();
    if (!au) return;
    var barras = (fig.dataset.wave || '').split(',').filter(function (x) { return x !== ''; });
    if (!barras.length) return;

    fig.dataset.pfReady = '1';

    /* --- onda: dos capas SVG (viewBox escalable, sin desbordes en movil) --- */
    var N = barras.length;
    var ns = 'http://www.w3.org/2000/svg';
    function capa(clase) {
      var s = document.createElementNS(ns, 'svg');
      s.setAttribute('class', 'pf-wave__s ' + clase);
      s.setAttribute('viewBox', '0 0 ' + N + ' 100');
      s.setAttribute('preserveAspectRatio', 'none');
      s.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < N; i++) {
        var v = Math.max(6, Math.min(100, parseFloat(barras[i]) || 6));
        var r = document.createElementNS(ns, 'rect');
        r.setAttribute('x', i.toFixed(2));
        r.setAttribute('y', (100 - v).toFixed(2));
        r.setAttribute('width', '0.62');
        r.setAttribute('height', v.toFixed(2));
        s.appendChild(r);
      }
      return s;
    }
    var capaB = capa(''), capaO = capa('on');
    wave.appendChild(capaB);
    wave.appendChild(capaO);

    var times = document.createElement('div');
    times.className = 'pf-player__times';
    var cur = document.createElement('span'); cur.className = 'pf-cur'; cur.textContent = '0:00';
    var tot = document.createElement('span'); tot.className = 'pf-tot'; tot.textContent = '0:00';
    times.appendChild(cur); times.appendChild(tot);

    var mid = document.createElement('div');
    mid.className = 'pf-player__mid';
    mid.appendChild(wave); mid.appendChild(times);

    var bot = document.createElement('button');
    bot.type = 'button';
    bot.className = 'pf-play';
    bot.setAttribute('aria-label', 'Reproducir');
    bot.appendChild(svg(['M8 5v14l11-7z']));
    var icoPause = svg(['M6 5h4v14H6z', 'M14 5h4v14h-4z']);
    icoPause.setAttribute('class', 'pf-ico-pause');
    bot.appendChild(icoPause);

    var right = document.createElement('div');
    right.className = 'pf-player__right';
    var b15 = document.createElement('button');
    b15.type = 'button'; b15.className = 'pf-sk'; b15.dataset.skip = '-15';
    b15.setAttribute('aria-label', 'Retroceder 15 segundos'); b15.innerHTML = '&#8722;15';
    var b15m = document.createElement('button');
    b15m.type = 'button'; b15m.className = 'pf-sk'; b15m.dataset.skip = '15';
    b15m.setAttribute('aria-label', 'Avanzar 15 segundos'); b15m.innerHTML = '+15';
    var vel = document.createElement('button');
    vel.type = 'button'; vel.className = 'pf-speed';
    vel.setAttribute('aria-label', 'Velocidad de reproducción'); vel.textContent = '1\u00d7';
    right.appendChild(b15); right.appendChild(b15m); right.appendChild(vel);

    var player = document.createElement('div');
    player.className = 'pf-player';
    player.appendChild(bot); player.appendChild(mid); player.appendChild(right);

    /* sustituir el reproductor nativo por el propio */
    au.style.display = 'none';
    fig.insertBefore(player, au);

    var velocidades = [1, 1.25, 1.5, 2], iv = 0;

    function pintar() {
      var d = au.duration;
      var pct = (isFinite(d) && d > 0) ? Math.min(100, Math.max(0, (au.currentTime / d) * 100)) : 0;
      capaO.style.clipPath = 'inset(0 ' + (100 - pct).toFixed(2) + '% 0 0)';
      cur.textContent = fmt(au.currentTime);
      if (isFinite(d) && d > 0) tot.textContent = fmt(d);
      wave.setAttribute('aria-valuenow', Math.round(pct));
    }

    function seek(f) {
      var d = au.duration;
      if (isFinite(d) && d > 0) au.currentTime = Math.min(d - 0.3, Math.max(0, f * d));
      pintar();
    }

    bot.addEventListener('click', function () { if (au.paused) au.play(); else au.pause(); });
    au.addEventListener('play', function () {
      fig.classList.add('is-playing');
      document.querySelectorAll('[data-press-audio]').forEach(function (o) {
        if (o !== fig) { var a = o.querySelector('audio'); if (a && !a.paused) a.pause(); }
      });
    });
    au.addEventListener('pause', function () { fig.classList.remove('is-playing'); });
    au.addEventListener('ended', function () { fig.classList.remove('is-playing'); pintar(); });
    au.addEventListener('timeupdate', pintar);
    au.addEventListener('loadedmetadata', pintar);
    au.addEventListener('durationchange', pintar);

    right.querySelectorAll('.pf-sk').forEach(function (b) {
      b.addEventListener('click', function () {
        au.currentTime = Math.max(0, Math.min((au.duration || 0) - 0.3, au.currentTime + parseFloat(b.dataset.skip)));
        pintar();
      });
    });
    vel.addEventListener('click', function () {
      iv = (iv + 1) % velocidades.length;
      au.playbackRate = velocidades[iv];
      vel.textContent = String(velocidades[iv]).replace('.', ',') + '\u00d7';
    });

    function desde(e) {
      var r = wave.getBoundingClientRect();
      var x = (e.clientX !== undefined ? e.clientX : e.touches[0].clientX) - r.left;
      seek(Math.min(1, Math.max(0, x / r.width)));
    }
    wave.addEventListener('click', desde);
    wave.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { au.currentTime = Math.min((au.duration || 0) - 0.3, au.currentTime + 5); pintar(); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { au.currentTime = Math.max(0, au.currentTime - 5); pintar(); e.preventDefault(); }
      if (e.key === ' ' || e.key === 'Enter') { if (au.paused) au.play(); else au.pause(); e.preventDefault(); }
    });

    if (!isFinite(au.duration) || !au.duration) { au.load && au.load(); }
    pintar();
  }

  document.querySelectorAll('[data-press-audio]').forEach(build);

  /* copiar el enlace del recorte */
  document.querySelectorAll('[data-pf-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = b.dataset.pfCopy || location.href;
      var ok = function () { b.classList.add('is-ok'); setTimeout(function () { b.classList.remove('is-ok'); }, 1700); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(t).then(ok, ok);
      } else {
        var i = document.createElement('input');
        i.value = t; document.body.appendChild(i); i.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(i); ok();
      }
    });
  });
})();
